<template>
  <div class>
    <!--        个人资料-->
    <el-card shadow="always">
      <div slot="header" class="fr ac jsb">
        <span>个人资料</span>
        <el-button type="text" style=" padding: 3px 0" @click="go('/me/profile')">详情</el-button>
      </div>
      <div class="member-info fr ac">
        <img class="member-img" :src="memberInfo.member_img"/>
        <div class="fc jsb ml20">
          <div class="fr ac">
            <span>{{ memberInfo.member_nick_name ? memberInfo.member_nick_name : '佚名' }}</span>
            <div v-if="memberInfo.role_ids" class="member-role ml30">{{ memberInfo.role_ids | role_name }}
            </div>
          </div>
          <div class="mt20">{{ memberInfo.member_account }}</div>
        </div>
      </div>
    </el-card>

    <!--        企业资料-->
    <el-card shadow="always" class="mt30" v-if="hasMemberType(2)">
      <div slot="header" class="fr ac jsb">
        <span>企业资料</span>
        <el-button v-if="$store.state.memberInfo.company_num > 1" type="text" style=" padding: 3px 0"
                   @click="getMemberCompanyList">切换公司
        </el-button>
      </div>
      <div class="company-info-box fr">
        <!--                左边-->

        <div class="fr ac pr20" style="width: 648px;border-right: 1px solid #f5f5f5;">
          <div>
            <img :src="company_info.company_logo" class="company-logo" alt/>
          </div>
          <div class="ml20">
            <div class="ellipsis-1line">{{ company_info.company_name }}</div>
            <div class="ellipsis-1line grey">{{ company_info.company_tel }}</div>
            <div class="mt10 grey ellipsis-2line">
              {{
                company_info.company_province + company_info.company_city + company_info.company_country + company_info.company_address
              }}
            </div>
          </div>
        </div>
        <!--                右边-->
        <div class="fc jsb ml20">
          <div class="fr ac">
            <img class="avatar" src="/static/imgs/home/avatar.png" alt/>
            <div class="ml10">我的客服</div>
          </div>
          <div class="mt10 mb10 bb"></div>
          <div class="fr ac">
            <img class="avatar" src="/static/imgs/home/avatar.png" alt/>

            <div class="ml10">
              <div>我的销售</div>
              <div class="mt10">{{ company_info.sell_account }}</div>
            </div>
          </div>
        </div>
      </div>
    </el-card>
    <!--      供应商资料-->
    <el-card shadow="always" class="mt30" v-if="hasMemberType(3)">
      <div slot="header" class="fr ac jsb">
        <span>企业资料</span>
      </div>
      <div class="company-info-box fr ac">
        <!--                左边-->

        <img :src="merchants_info.merchants_logo" class="company-logo" alt/>

        <div class="ml20">
          <div>{{ merchants_info.merchants_name }}</div>
          <div class="mt20 grey">{{ merchants_info.merchants_tel }}</div>
          <div class="mt20 grey">
            {{
              merchants_info.merchants_province + merchants_info.merchants_city + merchants_info.merchants_country + merchants_info.merchants_address
            }}
          </div>
        </div>
      </div>
    </el-card>


    <!--        我的订单-->

    <el-card shadow="always" class="mt30" v-if="hasPermission(877)">
      <div slot="header" class="fr ac jsb">
        <span>我的订单</span>
      </div>
      <div class=" fr ac">
        <grid label="待确认" img="/static/imgs/me/pendingPayment.png" goUrl="myorder?type=1" v-if="hasPermission(878)"/>
        <grid label="待发货" img="/static/imgs/me/toBeDelivered.png" goUrl="myorder?type=4" v-if="hasPermission(879)"/>
        <grid label="待收货" img="/static/imgs/me/toBeReceived.png" goUrl="myorder?type=5" v-if="hasPermission(880)"/>
        <grid label="待评价" img="/static/imgs/me/comment.png" goUrl="myorder?type=6" v-if="hasPermission(881)"/>
        <grid label="售后" img="/static/imgs/me/after.png" goUrl="myorder?type=9999" v-if="hasPermission(882)"/>
      </div>
    </el-card>


    <!--        销售订单  平台销售-->
    <el-card shadow="always" class="mt30" v-if="$store.state.is_sales">
      <div slot="header" class="fr ac jsb">
        <span>订单管理</span>
      </div>
      <div class="fr ac">
        <grid label="待审核" img="/static/imgs/me/pendingPayment.png" goUrl="/me/salesOrder?order_state=1"/>
        <grid label="待发货" img="/static/imgs/me/toBeDelivered.png" goUrl="/me/salesOrder?order_state=2"/>
      </div>
    </el-card>


    <!--    供应商订单-->
    <el-card shadow="always" class="mt30" v-if="false">
      <div slot="header" class="fr ac jsb">
        <span>我的订单</span>
      </div>
      <div class="fr ac">
        <grid label="待确认" img="/static/imgs/me/pendingPayment.png" goUrl="/me/merchantsOrder"/>
        <grid label="生产中" img="/static/imgs/me/icon_producting.png" goUrl="/me/merchantsOrder"/>
        <grid label="待收货" img="/static/imgs/me/toBeReceived.png" goUrl="/me/merchantsOrder"/>
        <grid label="售后" img="/static/imgs/me/after.png" goUrl="/me/merchantsOrder"/>
      </div>
    </el-card>


    <!--        我的服务-->
    <el-card shadow="always" class="mt30" v-if="hasMemberType([2])">
      <div slot="header" class="fr ac jsb">
        <span>我的服务</span>
      </div>
      <div class="fr ac">
        <!--        <grid label="我的合同" :permission_id="2" img="/static/imgs/me/contract.png" goUrl="/me/mycontract"/>-->
        <grid label="服务订单" :permission_id="3" img="/static/imgs/me/icon_service.png" goUrl="/me/myservice"
              v-if="hasPermission([3])"/>
        <grid label="我的设备" :permission_id="4" img="/static/imgs/me/icon_equipment.png" goUrl="/me/mydevice"
              v-if="hasPermission([4222])"/>
        <grid label="发票管理" :permission_id="5" img="/static/imgs/me/icon_invoice.png" goUrl="/me/invoice"
              v-if="hasPermission([5])"/>
        <grid label="财务管理" :permission_id="6" img="/static/imgs/me/icon_finance.png" goUrl="/me/finance"
              v-if="hasPermission([6])"/>
        <grid label="地址管理" :permission_id="7" img="/static/imgs/me/icon_address.png" goUrl="/me/myaddress"
              v-if="hasPermission([7])"/>
        <grid label="我的收藏" :permission_id="8" img="/static/imgs/me/icon_ht.png" goUrl="/collection"
              v-if="hasPermission([8])"/>
      </div>
    </el-card>
    <!--   销售     分销中心-->

    <el-card shadow="always" class="mt30" v-if="$store.state.is_part_time_sale || $store.state.is_sales">
      <div slot="header" class="fr ac jsb">
        <span>分销中心</span>
      </div>
      <div class="fr ac">
        <grid label="我的客户" :permission_id="11" img="/static/imgs/me/icon_company.png" goUrl="/me/myCustomer"
              v-if="hasPermission([637,332])"/>
        <grid label="我的收益" :permission_id="12" img="/static/imgs/me/icon_income.png" goUrl="/me/myIncome"
              v-if="hasPermission([333,12])"/>
        <grid label="我的团队" :permission_id="13" img="/static/imgs/me/icon_sx.png" goUrl="/me/myRelation"
              v-if="hasPermission([668,334])"/>
        <grid label="我的二维码" :permission_id="14" img="/static/imgs/me/icon_qr.png" goUrl="/me/qrcode"
              v-if="hasPermission([673,335])"/>
        <grid label="我的担保" :permission_id="16" img="/static/imgs/me/icon_guarantee.png" goUrl="/me/guarantee"
              v-if="hasPermission([16,697])"/>
        <grid label="服务订单" :permission_id="17" img="/static/imgs/me/icon_service.png" goUrl="/me/salesservice"
              v-if="hasPermission([17,700])"/>
        <grid label="我的银行卡" :permission_id="8" img="/static/imgs/me/icon_card.png" goUrl="/me/mybankcard"
              v-if="hasPermission([783,779])"/>
        <grid label="出差报告" :permission_id="554" img="/static/imgs/me/icon_travel_report.png" goUrl="/me/travelReport"
              v-if="hasPermission(554)"/>
      </div>
    </el-card>
    <!--      技术服务合伙人-->
    <el-card shadow="always" class="mt30" v-if="$store.state.is_technician || $store.state.is_platform_technician">
      <div slot="header" class="fr ac jsb">
        <span>技术服务</span>
      </div>
      <div class="fr ac">
        <grid label="服务订单" :permission_id="11" img="/static/imgs/me/icon_service.png" goUrl="/me/technician"
              v-if="hasPermission([785,760])"/>
        <grid label="文章收藏" :permission_id="12" img="/static/imgs/me/icon_ht.png" goUrl="/collection"
              v-if="hasPermission(802)"/>
        <grid label="我的收益" :permission_id="12" img="/static/imgs/me/icon_income.png" goUrl="/me/myIncome"
              v-if="hasPermission([781,12])"/>
        <grid label="我的银行卡" :permission_id="8" img="/static/imgs/me/icon_card.png" goUrl="/me/mybankcard"
              v-if="hasPermission([783,779])"/>
        <grid label="我的文章" :permission_id="13" img="/static/imgs/me/icon_article.png" goUrl="/me/myInformation"
              v-if="hasPermission(9999)"/>
      </div>
    </el-card>

    <!--供应商服务-->
    <div class="mt30" v-if="false">
      <div class="fz18">供应商服务</div>

      <div class="merchants mt10 fr ac">
        <div class="item cursor">
          <div>
            <img
                @click="go('/me/merchantsContract')"
                v-if="hasPermission(19)"
                src="/static/imgs/me/contract.png"
                style="width: 34px;height: 34px"
                alt
            />
            <img
                v-if="!hasPermission(19)"
                src="/static/imgs/me/iocn_ht_d@2x.png"
                style="width: 34px;height: 34px"
                alt
            />
          </div>

          <div class="mt10">我的合同</div>
        </div>
        <div class="item cursor">
          <div>
            <img
                @click="go('/me/myInformation')"
                v-if="hasPermission(20)"
                src="/static/imgs/me/icon_article.png"
                style="width: 34px;height: 34px"
                alt
            />
            <img
                v-if="!hasPermission(20)"
                src="/static/imgs/me/icon_wenzhang_d@2x.png"
                style="width: 34px;height: 34px"
                alt
            />
          </div>

          <div class="mt10">我的文章</div>
        </div>
      </div>
    </div>
    <!--        我的同事-->
    <el-card shadow="always" class="mt30" v-if="hasMemberType([2,3])">
      <div slot="header" class="fr ac jsb">
        <span>我的同事</span>
      </div>
      <div class="workmate">
        <div class="item fr jsb ac" v-for="(item,index) in workmate_list" :key="index">
          <div class="fr ac">
            <img :src="item.member_img" class="colleague-img" alt/>

            <div class="ml20">
              <div class="fr ac">
                <p>{{ item.member_nick_name }}</p>
                <p class="member-role ml40">
                  {{ role_name(item.memberRoleBean.role_id, item.memberRoleBean.auth_type) }}
                </p>
              </div>
              <p class="mt20">{{ item.member_account }}</p>
            </div>
          </div>
          <i class="el-icon-arrow-right fz28"/>
        </div>
      </div>
    </el-card>
    <re-dialog :visible.sync="switch_show" title="切换公司" width="700px">
      <el-table
          border
          :data="company_list"
          ref="singleTable"
          header-align="center"
          style="width: 100%"
          highlight-current-row
          @row-click="showRow"
      >
        <el-table-column label="操作" width="70" align="center">
          <template slot-scope="scope">
            <el-radio class="radio" v-model="company_id" :label="scope.row.company_id">&nbsp;</el-radio>
          </template>
        </el-table-column>
        <el-table-column prop="company_name" label="公司名称" align="center"></el-table-column>
        <el-table-column prop="contact_name" label="联系人" align="center"></el-table-column>
        <el-table-column prop="contact_mobile" label="联系人手机号" align="center"></el-table-column>
      </el-table>
      <div class="fr ac jc" slot="footer">
        <el-button type="primary" style="width:30%" @click="confirmSwitch">确认切换</el-button>
      </div>
    </re-dialog>
  </div>
</template>

<script>
import grid from "../../../components/grid";

export default {
  data() {
    return {
      memberInfo: this.$store.state.memberInfo,
      company_info: {},
      merchants_info: {},
      workmate_list: [],
      company_list: [],
      switch_show: false,
      company_id: null,
      switch_info: {}
    };
  },
  mounted() {
    if (this.hasMemberType(2)) {
      this.getCompanyDetail();
      this.getWorkMateList();
    }
  },
  computed: {
    filterRole() {
      if (this.hasRole([10, 11])) {
        return "总管理员";
      }
      if (this.hasRole(2)) {
        return "采购";
      }
      if (this.hasRole([3, 6, 9])) {
        return "财务";
      }
      if (this.hasRole([1, 4, 7])) {
        return "技术员";
      }
      if (this.hasRole(5)) {
        return "销售";
      }
      if (this.hasRole(8)) {
        return this.$store.state.memberInfo.sell_level_name || "新销售";
      }
      if (this.hasRole(12)) {
        return "客服";
      }
      return "普通用户";
    },
  },
  methods: {
    confirmSwitch() {
      this.switch_show = false;
      if (this.company_id !== Number(this.$store.state.memberInfo.company_id)) {
        this.$store.commit('setSwitchCompany', this.switch_info);
        this.$message.success('已切换！');
        setTimeout(() => {
          this.redirect('/');
        }, 2000)
      }
    },
    showRow(row) {
      this.switch_info = row;
      this.company_id = row.company_id;
    },
    getMemberCompanyList() {
      this.company_id = Number(this.$store.state.memberInfo.company_id);
      this.post("companyInterfaces/v1.0/getMemberCompanyList", {}).then(res => {
        this.company_list = res.data;
        this.switch_show = true;
      })
    },
    isReedProtocol(html_id) {
      let param = {
        html_id: html_id,
      };
      this.post("settingInterfaces/v1.0/isReadHtml", param).then((res) => {
        if (res.data != "1") {
          this.go("/protocol?html_id=" + html_id);
        }
      });
    },
    //获取公司详情
    getCompanyDetail() {
      let param = {};
      this.post("companyInterfaces/v1.0/getCompanyDetail", param).then(
          (res) => {
            this.company_info = res.data;
          }
      );
    },
    //获取供应商详情
    getMerchantsDetail() {
      let param = {};
      this.post("merchantsInterfaces/v1.0/getMerchantsDetail", param).then(
          (res) => {
            this.merchants_info = res.data;
          }
      );
    },
    //    获取同事列表
    getWorkMateList() {
      let auth_type = "";
      let relation_id = "";

      if (this.hasMemberType(2)) {
        auth_type = 2;
        relation_id = this.memberInfo.company_id;
      }

      if (this.hasMemberType(3)) {
        auth_type = 3;
        relation_id = this.memberInfo.merchants_id;
      }

      if (this.hasMemberType(4)) {
        auth_type = 4;
        relation_id = -1;
      }

      let param = {
        auth_type: auth_type,
        relation_id: relation_id,
      };
      this.post("memberRoleInterfaces/v1.0/getCompanyWorkmateList", param).then(
          (res) => {
            this.workmate_list = res.data;
          }
      );
    },
  },
  filters: {
    role_name(v) {
      let name = v;
      let s = "";
      if (name.length > 1) {
        s = name[1];
      } else {
        s = name[0];
      }
      switch (s) {
        case 1:
        case 4:
        case 7:
        case 15:
          return "技术员";
          break;
        case 2:
        case 16:
          return "采购";
          break;
        case 3:
        case 6:
        case 9:
          return "财务";
          break;
        case 5:
        case 8:
        case 13:
          return "销售";
          break;
        case 12:
          return "客服";
          break;
        case 10:
        case 14:
          return "管理员";
          break;

        default:
          return "";
          break;
      }
    },
  },
  components: {grid}
};
</script>

<style scoped lang="scss">
/*个人资料*/
.member-img {
  width: 60px;
  height: 60px;
  border-radius: 50%
}

.member-role {
  width: 78px;
  height: 22px;
  background: rgb(69, 142, 246);
  display: flex;
  justify-content: center;
  align-items: center;
  color: white;
}

.company-info-box {
  width: 100%;

  .company-logo {
    width: 80px;
    height: 80px
  }

  .avatar {
    width: 40px;
    height: 40px;
  }
}

/*    企业资料*/
.company-info {
  width: 920px;
  //height: 134px;
  background: #fff;
  box-shadow: 0 0 20px rgba(0, 0, 0, 0.16);
}

/*    我的订单*/
.order {
  width: 920px;
  height: 140px;
  background: rgba(255, 255, 255, 1);
  box-shadow: 0px 0px 20px rgba(0, 0, 0, 0.16);
  opacity: 1;

  .item {
    width: 172px;
    /*flex-grow: 1;*/
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
  }
}

/*    我的服务*/
.service {
  width: 920px;
  height: 103px;
  background: rgba(255, 255, 255, 1);
  box-shadow: 0px 0px 20px rgba(0, 0, 0, 0.16);
  opacity: 1;

  .item {
    width: 115px;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
  }
}

/*    我的同事*/
.workmate {
  width: 100%;

  .item {
    height: 100px;
    border-bottom: 1px solid #e5e5e5;

    .colleague-img {
      width: 60px;
      height: 60px;
    }

    &:last-child {
      border-bottom: none;
    }
  }
}

/*    供应商服务*/
.merchants {
  width: 920px;
  height: 103px;
  background: rgba(255, 255, 255, 1);
  box-shadow: 0px 0px 20px rgba(0, 0, 0, 0.16);
  opacity: 1;

  .item {
    width: 115px;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
  }
}
</style>


// WEBPACK FOOTER //
// src/page/me/entrance/index.vue